import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Instagram, ExternalLink } from "lucide-react";
import { publicApi } from "@/lib/api";

const InstaFeed = ({ handle = "andamanavalon", profileUrl = "https://www.instagram.com/" }) => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicApi.get("/insta-photos")
      .then((r) => setPhotos(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (!loading && photos.length === 0) return null;

  return (
    <section className="py-24 bg-background" data-testid="insta-feed-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#f09433] via-[#dc2743] to-[#bc1888] p-[3px] mb-4">
            <div className="w-full h-full rounded-full bg-white flex items-center justify-center">
              <Instagram className="text-[#dc2743]" size={30} />
            </div>
          </div>
          <span className="accent-label text-secondary">FOLLOW OUR JOURNEY</span>
          <h2 className="text-4xl sm:text-5xl font-serif mt-3 text-primary">@{handle}</h2>
          <p className="text-muted-foreground mt-3 max-w-xl">
            Real moments from real travellers. Tag us <b>@{handle}</b> to be featured.
          </p>
          <a
            href={profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="insta-follow-btn"
            className="mt-5 inline-flex items-center gap-2 px-6 py-2.5 rounded-full text-white font-medium hover:opacity-90 transition-opacity"
            style={{ background: "linear-gradient(45deg, #f09433, #dc2743, #bc1888)" }}
          >
            <Instagram size={16} /> Follow on Instagram
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 sm:gap-3">
          {photos.slice(0, 8).map((p, i) => (
            <motion.a
              key={p.id}
              href={p.link || profileUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`insta-photo-${i}`}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="relative group aspect-square overflow-hidden rounded-lg"
            >
              <img
                src={p.image_url}
                alt={p.caption || `Andaman Avalon photo ${i + 1}`}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                <div className="text-white text-center px-3">
                  <Instagram size={20} className="mx-auto mb-1" />
                  {p.caption && <p className="text-xs leading-tight line-clamp-2">{p.caption}</p>}
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstaFeed;
